// Admin CMS configuration: collections, labels, and blank templates for new items.

export const COLLECTIONS = {
  home_sections: {
    label: "Homepage", singular: "Section", reorder: true, noCreate: true, noDelete: true,
    titleKey: "name",
  },
  services: {
    label: "Services", singular: "Layanan", reorder: true, titleKey: "name",
    template: {
      name: "", slug: "", icon: "star", short_description: "", long_description: "",
      hero_image: "", thumbnail: "", seo_title: "", seo_description: "", primary_keyword: "",
      secondary_keywords: [], benefits: [], deliverables: [], pain_points: [],
      process: [], faq: [], price_visible: false, price_label: "Konsultasikan Kebutuhan",
      price_min: null, price_max: null, currency: "Rp", price_notes: "",
      cta_text: "Konsultasi", cta_destination: "/contact",
      featured: false, flagship: false, active: true,
    },
  },
  portfolio: {
    label: "Portfolio", singular: "Project", reorder: true, titleKey: "title",
    template: {
      title: "", slug: "", client: "", industry: "", year: "", services_used: [], related_services: [],
      cover_image: "", gallery: [], summary: "", challenge: "", strategy: "", execution: "", results: "",
      metrics: [], seo_title: "", seo_description: "", featured: false, published: true,
    },
  },
  blog_posts: {
    label: "Blog", singular: "Artikel", titleKey: "title", ai: true,
    template: {
      title: "", slug: "", category: "", tags: [], author: "Tim Digitalis", status: "draft",
      featured: false, cover_image: "", excerpt: "", content: "", seo_title: "", seo_description: "",
      primary_keyword: "", related_services: [], published_at: null,
    },
  },
  blog_categories: {
    label: "Kategori Blog", singular: "Kategori", reorder: true, titleKey: "name",
    template: { name: "", slug: "" },
  },
  pricing_tabs: {
    label: "Harga & Paket", singular: "Tab Harga", reorder: true, titleKey: "name",
    template: {
      name: "", slug: "", subtitle: "", wa_message: "", active: true,
      packages: [{ title: "Paket 1", price: "Rp0", period: "/bulan", highlighted: false, features: ["Fitur 1", "Fitur 2"] }],
    },
  },
  testimonials: {
    label: "Testimoni", singular: "Testimoni", reorder: true, titleKey: "name",
    template: { name: "", company: "", position: "", photo: "", quote: "", related_service: "", featured: false, published: false, is_demo: true },
  },
  clients: {
    label: "Client Logo", singular: "Client", reorder: true, titleKey: "name",
    template: { name: "", logo: "", url: "", alt: "", active: true },
  },
  team: {
    label: "Tim", singular: "Anggota", reorder: true, titleKey: "name",
    template: { name: "", role: "", bio: "", photo: "" },
  },
  faqs: {
    label: "FAQ", singular: "FAQ", reorder: true, titleKey: "q",
    template: { q: "", a: "", category: "umum" },
  },
  navigation: {
    label: "Navigasi", singular: "Menu", reorder: true, titleKey: "label",
    template: { label: "", url: "", new_tab: false, visible: true },
  },
  media: {
    label: "Media Library", singular: "Media", titleKey: "title",
    template: { title: "", url: "", alt: "", caption: "", credit: "" },
  },
};

// Field label overrides (Indonesian)
export const FIELD_LABELS = {
  name: "Nama", title: "Judul", slug: "Slug (URL)", short_description: "Deskripsi Singkat",
  long_description: "Deskripsi Lengkap", hero_image: "Gambar Hero", thumbnail: "Thumbnail",
  seo_title: "SEO Title", seo_description: "Meta Description", primary_keyword: "Keyword Utama",
  secondary_keywords: "Keyword Pendukung", benefits: "Benefits", deliverables: "Deliverables",
  pain_points: "Pain Points", process: "Proses (JSON)", faq: "FAQ (JSON)",
  price_visible: "Tampilkan Harga", price_label: "Label Harga", price_min: "Harga Minimum",
  price_max: "Harga Maksimum", currency: "Mata Uang", price_notes: "Catatan Harga",
  cta_text: "Teks CTA", cta_destination: "Tujuan CTA", featured: "Featured", flagship: "Flagship",
  active: "Aktif", published: "Dipublikasikan", status: "Status (draft/published)",
  category: "Kategori", tags: "Tags", author: "Penulis", cover_image: "Gambar Cover",
  excerpt: "Ringkasan", content: "Konten (HTML)", related_services: "Layanan Terkait (slug)",
  client: "Klien", industry: "Industri", year: "Tahun", services_used: "Layanan Digunakan",
  gallery: "Galeri (URL)", summary: "Ringkasan", challenge: "Tantangan", strategy: "Strategi",
  execution: "Eksekusi", results: "Hasil", metrics: "Metrics (JSON)", company: "Perusahaan",
  position: "Jabatan", photo: "Foto", quote: "Kutipan", logo: "Logo", url: "URL", alt: "Alt Text",
  caption: "Caption", credit: "Kredit", role: "Peran", bio: "Bio", q: "Pertanyaan", a: "Jawaban",
  label: "Label", new_tab: "Buka Tab Baru", visible: "Terlihat", icon: "Ikon (lucide)",
  packages: "Paket Harga (JSON)", wa_message: "Pesan WhatsApp", period: "Periode",
  features: "Fitur", highlighted: "Paket Unggulan", price: "Harga",
  enabled: "Aktifkan Section", eyebrow: "Eyebrow", subtitle: "Subjudul", description: "Deskripsi",
  cta: "CTA", cta_link: "Link CTA", cta_primary: "CTA Utama", cta_primary_link: "Link CTA Utama",
  cta_secondary: "CTA Sekunder", cta_secondary_link: "Link CTA Sekunder", image: "Gambar",
  location_signal: "Sinyal Lokasi", items: "Items (JSON)", secondary_label: "Label Sekunder",
};

export const HIDDEN_FIELDS = ["id", "created_at", "updated_at", "sort_order", "key", "ip"];
